(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Close the mobile drawer on Escape or when a link inside it is chosen.
  const drawer = $('.drawer');
  if (drawer) {
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.open) { drawer.open = false; $('summary', drawer).focus(); } });
    $$('a', drawer).forEach((a) => a.addEventListener('click', () => { drawer.open = false; }));
  }

  // Announcement bar: rotate messages on small screens, where only one fits.
  const ann = $('[data-ann]');
  if (ann && !reduce) {
    const items = $$('li', ann);
    let i = 0;
    if (items.length > 1) setInterval(() => {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 4500);
  }

  // Mega menu: keep aria-expanded in sync and close on Escape.
  $$('[data-mm]').forEach((mm) => {
    const top = $('.mm__top', mm);
    const set = (open) => { mm.classList.toggle('is-open', open); if (top) top.setAttribute('aria-expanded', String(open)); };
    mm.addEventListener('mouseenter', () => set(true));
    mm.addEventListener('mouseleave', () => set(false));
    mm.addEventListener('focusin', () => set(true));
    mm.addEventListener('focusout', (e) => { if (!mm.contains(e.relatedTarget)) set(false); });
    mm.addEventListener('keydown', (e) => { if (e.key === 'Escape') { set(false); if (top) top.focus(); } });
  });

  // Tabs (home page best sellers).
  $$('[role="tablist"]').forEach((list) => {
    const tabs = $$('[role="tab"]', list);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) $$('[data-rail]', panel).forEach(updateRail);
    };
    tabs.forEach((t, i) => {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        const next = tabs[(i + d + tabs.length) % tabs.length];
        next.focus(); select(next);
      });
    });
  });

  // Product rails: previous/next buttons scroll one card at a time.
  function updateRail(rail) {
    const track = $('[data-rail-track]', rail);
    const prev = $('[data-rail-prev]', rail);
    const next = $('[data-rail-next]', rail);
    if (!track || !prev || !next) return;
    prev.disabled = track.scrollLeft <= 4;
    next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  }
  $$('[data-rail]').forEach((rail) => {
    const track = $('[data-rail-track]', rail);
    if (!track) return;
    const step = (dir) => {
      const card = track.firstElementChild;
      const w = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
    };
    const prev = $('[data-rail-prev]', rail);
    const next = $('[data-rail-next]', rail);
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => updateRail(rail), { passive: true });
    window.addEventListener('resize', () => updateRail(rail));
    updateRail(rail);
  });

  // Collection filters: only one dropdown open at a time; close on outside click.
  const drops = $$('[data-fdrop]');
  drops.forEach((d) => d.addEventListener('toggle', () => { if (d.open) drops.forEach((o) => { if (o !== d) o.open = false; }); }));
  document.addEventListener('click', (e) => { drops.forEach((d) => { if (d.open && !d.contains(e.target)) d.open = false; }); });

  // Auto-submit sort selects, filter checkboxes and cart quantity changes.
  $$('[data-autosubmit]').forEach((el) => el.addEventListener('change', () => el.form && el.form.submit()));
  $$('[data-autosubmit-change]').forEach((el) => el.addEventListener('change', () => {
    const form = el.form; if (!form) return;
    const hidden = document.createElement('input'); hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
    form.append(hidden); form.submit();
  }));

  // Quantity steppers.
  $$('[data-qty]').forEach((b) => b.addEventListener('click', () => {
    const input = b.parentElement.querySelector('input'); if (!input) return;
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
  }));

  // Product gallery thumbnails.
  const track = $('[data-gal]');
  const thumbs = $$('[data-thumb]');
  const showMedia = (id) => {
    const slide = track && $('[data-media-id="' + id + '"]', track);
    if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === String(id))));
  };
  thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.thumb)));
  if (track && thumbs.length) {
    let timer;
    track.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        const slide = track.children[i];
        if (slide) thumbs.forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === slide.dataset.mediaId)));
      }, 80);
    }, { passive: true });
  }

  // Sticky add-to-bag bar: show once the main button scrolls out of view.
  const satc = $('[data-satc]');
  const mainAdd = $('[data-product-root] [data-add]');
  if (satc && mainAdd && 'IntersectionObserver' in window) {
    satc.hidden = false;
    new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      satc.classList.toggle('is-on', past);
      satc.toggleAttribute('inert', !past);
    }).observe(mainAdd);
    satc.toggleAttribute('inert', true);
  }

  // Variant selection.
  const root = $('[data-product-root]');
  const variantsEl = root && $('[data-variants]', root);
  if (!root || !variantsEl) return;
  let variants = [];
  let labels = {};
  try { variants = JSON.parse(variantsEl.textContent); labels = JSON.parse($('[data-labels]', root).textContent); } catch (e) { return; }
  const sets = $$('fieldset[data-option-index]', root);
  if (!sets.length) return;
  const idInput = $('[data-variant-id]', root);
  const addBtn = $('[data-add]', root);
  const addLabel = $('[data-add-label]', root);
  const now = $('[data-price-now]', root);
  const was = $('[data-price-was]', root);
  const satcPrice = $('[data-satc-price]');
  const satcBtn = $('[data-satc-btn]');

  const selected = () => sets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
  const update = () => {
    const sel = selected();
    sets.forEach((fs, i) => { const l = $('[data-option-label]', fs); if (l) l.textContent = sel[i] || ''; });
    // Mark values that have no available variant with the other current choices.
    sets.forEach((fs, i) => {
      $$('.pill', fs).forEach((pill) => {
        const val = $('input', pill).value;
        const ok = variants.some((v) => v.available && v.options[i] === val && v.options.every((o, j) => j === i || o === sel[j]));
        pill.classList.toggle('is-off', !ok);
      });
    });
    const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
    if (!v) { addBtn.disabled = true; addLabel.textContent = labels.unavailable; if (satcBtn) satcBtn.disabled = true; return; }
    idInput.value = v.id;
    now.textContent = v.price;
    if (satcPrice) satcPrice.textContent = v.price;
    if (v.compare) { was.textContent = v.compare; was.hidden = false; } else { was.hidden = true; }
    addBtn.disabled = !v.available;
    if (satcBtn) satcBtn.disabled = !v.available;
    addLabel.textContent = v.available ? labels.add : labels.soldout;
    if (v.media) showMedia(v.media);
    const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
  };
  sets.forEach((fs) => fs.addEventListener('change', update));
  update();
})();
